import React from "react";
import { View } from "react-native";
import Skeletons from "./Skeletons";

const SupportChatSkeleton = () => {
  let skeletonCards = Array(10).fill(0);

  return (
    <View style={{ flex: 1, flexDirection: "column", marginHorizontal: 20 }}>
      <View style={{ flexDirection: "row", justifyContent: "center" }}>
        <View
          style={{
            flex: 1,
            flexDirection: "column",
            marginHorizontal: 20,
            width: "100%",
          }}
        >
          {skeletonCards.map((_, index) => (
            <View
              key={index}
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                borderRadius: 12,
                marginVertical: 10,
                height: 32,
              }}
            >
              <View style={{ flex: 1, paddingHorizontal: 5 }}>
                <Skeletons
                  height={32}
                  style={{
                    flexDirection: "row",
                    borderRadius: 10,
                    width: "100%",
                  }}
                />
              </View>
              <View style={{ flex: 1, paddingHorizontal: 5 }}>
                <Skeletons
                  height={32}
                  style={{
                    flexDirection: "row",
                    borderRadius: 10,
                    width: "100%",
                  }}
                />
              </View>
              <View style={{ flex: 1, paddingHorizontal: 5 }}>
                <Skeletons
                  height={32}
                  style={{
                    flexDirection: "row",
                    borderRadius: 10,
                    width: "100%",
                  }}
                />
              </View>
              <View style={{ flex: 1, paddingHorizontal: 5 }}>
                <Skeletons
                  height={32}
                  style={{
                    flexDirection: "row",
                    borderRadius: 10,
                    width: "100%",
                  }}
                />
              </View>
              <View style={{ flex: 1, paddingHorizontal: 5 }}>
                <Skeletons
                  height={32}
                  style={{
                    flexDirection: "row",
                    borderRadius: 10,
                    width: "100%",
                  }}
                />
              </View>
            </View>
          ))}
        </View>
      </View>
    </View>
  );
};

export default SupportChatSkeleton;
